import { Component, Input } from '@angular/core';

@Component({
  selector: 'mac-icon',
  templateUrl: './icon.component.html',
  standalone: false,
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  @Input() icon: string;
  @Input() class?: string | undefined;
  @Input() style?: string | undefined;
}
